import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { numberFormat } from '../../helpers';
import moment from 'moment';

const CreditLists = ({ creditDatas }) => {
    return (
        <Card className="mb-4" style={{ boxShadow: 'none' }}>
            <Card.Body>
                <Card.Title>ລາຍການ {creditDatas?.total ?? 0 }</Card.Title>
                <Table>
                    <thead style={{ borderBottom: 'none' }}>
                        <tr>
                            <th>ລຳດັບ</th>
                            <th>ຈຳນວນເງິນ</th>
                            <th>ທະນາຄານ</th>
                            <th>ປະເພດການຊຳລະ</th>
                            <th>ວັນທີ,ເດືອນ,ປີ</th>
                            <th>ສະຖານະບິນ</th>
                            <th>ໝາຍເຫດ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {creditDatas?.data.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{numberFormat(item?.amount)}</td> 
                                <td>{item?.origin}</td> 
                                <td>-</td> 
                                <td>{moment(item?.createdAt).format("DD/MM/YYY : HH:ss")}</td> 
                                <td>-</td> 
                                <td>-</td> 
                            </tr>
                        ))}

                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
};

export default CreditLists;
